/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * naming object
 * @export
 * @interface PutFleetsFleetIdWingsWingIdNaming
 */
export interface PutFleetsFleetIdWingsWingIdNaming {
    /**
     * name string
     * @type {string}
     * @memberof PutFleetsFleetIdWingsWingIdNaming
     */
    name: string;
}

/**
 * Check if a given object implements the PutFleetsFleetIdWingsWingIdNaming interface.
 */
export function instanceOfPutFleetsFleetIdWingsWingIdNaming(value: object): value is PutFleetsFleetIdWingsWingIdNaming {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PutFleetsFleetIdWingsWingIdNamingFromJSON(json: any): PutFleetsFleetIdWingsWingIdNaming {
    return PutFleetsFleetIdWingsWingIdNamingFromJSONTyped(json, false);
}

export function PutFleetsFleetIdWingsWingIdNamingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutFleetsFleetIdWingsWingIdNaming {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function PutFleetsFleetIdWingsWingIdNamingToJSON(json: any): PutFleetsFleetIdWingsWingIdNaming {
    return PutFleetsFleetIdWingsWingIdNamingToJSONTyped(json, false);
}

export function PutFleetsFleetIdWingsWingIdNamingToJSONTyped(value?: PutFleetsFleetIdWingsWingIdNaming | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

